export const checkIfPopupExists = (popupId: string, currentWebsite: any) => {
  if (!currentWebsite.popups) return false;
  if (!currentWebsite.popups.items) return false;

  const popupItems = currentWebsite.popups.items;
  const popupExists = popupItems.some((popupItem) => popupItem.id === popupId);

  return popupExists;
};
